import React, { Component } from 'react';
import  Constant from './CONST';
import { connect } from 'react-redux';
import { analytics } from '../../shared/Actions';
import '../commonCompStyles.css'


const skipDisclosureContentForPages = (currentPage= '') => {
    const listOfPagesToSkipDisclosure = ['/forms','/portfolioPlannerPdf','/documentCenter']
    return listOfPagesToSkipDisclosure.includes(currentPage)
}

const assignObj = obj => {
    return obj;
};
let CONSTS = Constant
class DashboardDisclosure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginDataCounter:0
        };
    }

    render() { 
        return (
            <div>
                {
                !skipDisclosureContentForPages(this.props?.pathname) ? 
                <div className='existing-disclosure-content' data-test="existing-disclosure-content">

             
                    <h2 style={assignObj({ font: '700 16px/24px benton-sans', color: '#49494A', marginBottom :15})}>
                        {CONSTS.PRINCIPLE}
                    </h2>
                     <p style={assignObj({ font: '500 16px/24px benton-sans', color: '#49494A' })}>
                        <span>{CONSTS.victoryPARA2}</span> 
                     </p>
                </div>
                :
                <div className='hide-disclosure-content' data-testid="hide-disclosure-content"></div>
                }
            </div>
        )
    }
    
}

const mapStateToProps = state => ({
});

export const mapDispatchToProps = {
    ...analytics,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(DashboardDisclosure);
